import React from "react";
import {
  I2cInput,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import {
  dataMigInfo,
  dataMigAttr,
  inputChangeHandler,
} from "./FieldsListingLabels";
import MigrationNewProgram from "./MigrationNewProgram";
const NewMigrationForm = ({ control, handleValueChanges, methods, errors }) => {
  const handleDataMigInfoChange = (value) => {
    let updatedData = methods.getValues("pi_key_component_custodians");
    if (updatedData.includes(value)) {
      updatedData = updatedData.filter((card) => card !== value);
    } else {
      updatedData.push(value);
    }
    if (!updatedData.includes(3)) {
      methods.setValue("pi_key_component_custodians_other", "");
    }
    methods.setValue("pi_key_component_custodians", updatedData);
    methods.trigger();
    handleValueChanges();
  };

  const handleDataMigrationAttributeChange = (value) => {
    let updatedData = methods.getValues("pi_data_migration_attributes");
    if (updatedData.includes(value)) {
      updatedData = updatedData.filter((card) => card !== value);
    } else {
      updatedData.push(value);
    }
    if (!updatedData.includes(4)) {
      methods.setValue("pi_data_migration_attributes_other", "");
    }
    methods.setValue("pi_data_migration_attributes", updatedData);
    methods.trigger();
    handleValueChanges();
  };

  return (
    <div className="forms-instance">
      <div className="section-space">
        <div className="sub-heading mb-4">Data Migration Information</div>
        <div className="custom-label-light mb-16">
          Applicable only for migrations.{" "}
          <span>For data migration clients MUST submit the Security Keys.</span>
        </div>
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="4@md">
            <div className="single-field-wrapper mb-16">
              <Controller
                name="pi_current_processor_name"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    label="Current Processor Name"
                    placeholder="Enter Current Processor Name"
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    invalid={errors.pi_current_processor_name}
                    size="large"
                    name={"pi_current_processor_name"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.pi_current_processor_name &&
                  methods.formState.touchedFields.pi_current_processor_name
                    ? true
                    : false
                }
                message={
                  errors.pi_current_processor_name?.message ?? "Invalid input"
                }
              />
            </div>
          </div>
        </div>
        <div className="custom-label mb-16">
          Existing Clear Key Components Custodian
        </div>
        <Controller
          name="pi_key_component_custodians"
          control={control}
          render={({ field }) => (
            <I2cCheckboxGroup {...field}>
              <div i2c-grid="grid gap-sm">
                {dataMigInfo.map((card, index) => (
                  <I2cListItem
                    key={index}
                    i2c-grid="6@md 3@lg"
                    variant="receipt"
                    label={card.label}
                    sublabel=""
                    value=""
                    type="checkbox"
                    checked={methods
                      .watch("pi_key_component_custodians")
                      .includes(card.value)}
                    onI2cCheckboxClicked={() =>
                      handleDataMigInfoChange(card.value)
                    }
                  >
                    <I2cCheckbox
                      slot="prefix"
                      name="pi_dataMigrationInfo"
                      filled
                      value={card.value}
                      label=""
                      ignoreTab
                      checked={methods
                        .watch("pi_key_component_custodians")
                        .includes(card.value)}
                    ></I2cCheckbox>
                  </I2cListItem>
                ))}
              </div>
            </I2cCheckboxGroup>
          )}
        />
        {methods.watch("pi_key_component_custodians").includes(3) ? (
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="4@md">
              <div className="single-field-wrapper mt-16">
              <Controller
                name="pi_key_component_custodians_other"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    label="Enter Details"
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    invalid={errors.pi_key_component_custodians_other}
                    placeholder="Other Details"
                    size="large"
                    name={"pi_key_component_custodians_other"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.pi_key_component_custodians_other &&
                  methods.formState.touchedFields
                    .pi_key_component_custodians_other
                    ? true
                    : false
                }
                message={
                  errors.pi_key_component_custodians_other?.message ??
                  "Invalid input"
                }
              />
            </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="section-space">
        <div className="sub-heading mb-4">Data Migration Attributes</div>
        <div className="custom-label-light mb-16">
          Applicable only for migrations. Please select existing data to be
          migrated.
        </div>
        <Controller
          name="pi_data_migration_attributes"
          control={control}
          render={({ field }) => (
            <I2cCheckboxGroup {...field}>
              <div i2c-grid="grid gap-sm">
                {dataMigAttr.map((card, index) => (
                  <I2cListItem
                    key={index}
                    i2c-grid="4@md"
                    variant="receipt"
                    label={card.label}
                    sublabel=""
                    value=""
                    type="checkbox"
                    checked={methods
                      .watch("pi_data_migration_attributes")
                      .includes(card.value)}
                    onI2cCheckboxClicked={() =>
                      handleDataMigrationAttributeChange(card.value)
                    }
                  >
                    <I2cCheckbox
                      slot="prefix"
                      name="pi_dataMigAttr"
                      filled
                      value={card.value}
                      label=""
                      ignoreTab
                      checked={methods
                        .watch("pi_data_migration_attributes")
                        .includes(card.value)}
                      // onI2cChange={(e) =>
                      //   handleDataMigrationAttributeChange(card.value)
                      // }
                    ></I2cCheckbox>
                  </I2cListItem>
                ))}
              </div>
            </I2cCheckboxGroup>
          )}
        />
        {methods.watch("pi_data_migration_attributes").includes(4) && (
          <div i2c-grid="grid gap-sm">
            <div  iv i2c-grid="4@md">
              <div className="single-field-wrapper mt-16">
              <Controller
                name="pi_data_migration_attributes_other"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    label="Enter Details"
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    invalid={errors.pi_data_migration_attributes_other}
                    placeholder="Other Details"
                    size="large"
                    name={"pi_data_migration_attributes_other"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.pi_data_migration_attributes_other &&
                  methods.formState.touchedFields
                    .pi_data_migration_attributes_other
                    ? true
                    : false
                }
                message={
                  errors.pi_data_migration_attributes_other?.message ??
                  "Invalid input"
                }
              />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="section-space">
        <div className="sub-heading mb-16">Data Migration</div>
        <div className="single-field-wrapper">
          <Controller
            name="pi_migration_type"
            control={control}
            render={({ field }) => (
              <I2cRadioGroup
                {...field}
                value={methods.watch("pi_migration_type")}
                name="pi_migration_type"
                onI2cChange={(e) => {
                  methods.setValue("pi_mig_np_ecount_1", "");
                  methods.setValue("pi_mig_np_ecount_2", "");
                  methods.setValue("pi_mig_np_ecount_3", "");
                  methods.setValue("pi_mig_np_ecount_4", "");
                  methods.setValue("pi_mig_np_evalue_1", "");
                  methods.setValue("pi_mig_np_evalue_2", "");
                  methods.setValue("pi_mig_np_evalue_3", "");
                  methods.setValue("pi_mig_np_evalue_4", "");
                  methods.setValue("pi_mig_np_evolume_1", "");
                  methods.setValue("pi_mig_np_evolume_2", "");
                  methods.setValue("pi_mig_np_evolume_3", "");
                  methods.setValue("pi_mig_np_evolume_4", "");
                  methods.setValue("pi_ecount_1", "");
                  methods.setValue("pi_ecount_2", "");
                  methods.setValue("pi_ecount_3", "");
                  methods.setValue("pi_ecount_4", "");
                  methods.setValue("pi_evalue_1", "");
                  methods.setValue("pi_evalue_2", "");
                  methods.setValue("pi_evalue_3", "");
                  methods.setValue("pi_evalue_4", "");
                  methods.setValue("pi_evolume_1", "");
                  methods.setValue("pi_evolume_2", "");
                  methods.setValue("pi_evolume_3", "");
                  methods.setValue("pi_evolume_4", "");
                  field.onChange(e);
                  methods.trigger();
                  handleValueChanges();
                }}
              >
                {[
                  { label: "Migration Program", value: "migration-program" },
                  { label: "New Program", value: "new-program" },
                  { label: "Both", value: "both" },
                ].map((cp, index) => (
                  <I2cRadioButton
                    key={index}
                    name="pi_setupType"
                    value={cp.value}
                  >
                    {cp.label}
                  </I2cRadioButton>
                ))}
              </I2cRadioGroup>
            )}
          />
          <ErrorMessage
            show={
              errors.pi_migration_type &&
              methods.formState.touchedFields.pi_migration_type
                ? true
                : false
            }
            message={errors.pi_migration_type?.message ?? "Invalid input"}
          />
        </div>
      </div>
      {(methods.watch("pi_migration_type") === "migration-program" ||
        methods.watch("pi_migration_type") === "both") && (
        <div className="section-space">
          <div className="sub-heading mb-4">Migration Program Projections</div>
          <div className="custom-label-light mb-16">
            Estimates for the first year.
          </div>
          <div className="custom-label mb-6">
            Estimated Count{" "}
            <span className="custom-label-light">
              (Number of cards to be migrated)
            </span>
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_1"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_ecount_1 &&
                    methods.formState.touchedFields.pi_ecount_1
                      ? true
                      : false
                  }
                  message={errors.pi_ecount_1?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_2"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_ecount_2 &&
                    methods.formState.touchedFields.pi_ecount_2
                      ? true
                      : false
                  }
                  message={errors.pi_ecount_2?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_3"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_ecount_3 &&
                    methods.formState.touchedFields.pi_ecount_3
                      ? true
                      : false
                  }
                  message={errors.pi_ecount_3?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_4"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_ecount_4 &&
                    methods.formState.touchedFields.pi_ecount_4
                      ? true
                      : false
                  }
                  message={errors.pi_ecount_4?.message ?? "Invalid input"}
                />
              </div>
            </div>
          </div>
          <div className="custom-label mb-6 mt-16">
            Estimated Value{" "}
            <span className="custom-label-light">
              (Transaction value of the migrated cards)
            </span>
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_1"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evalue_1 &&
                    methods.formState.touchedFields.pi_evalue_1
                      ? true
                      : false
                  }
                  message={errors.pi_evalue_1?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_2"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evalue_2 &&
                    methods.formState.touchedFields.pi_evalue_2
                      ? true
                      : false
                  }
                  message={errors.pi_evalue_2?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_3"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evalue_3 &&
                    methods.formState.touchedFields.pi_evalue_3
                      ? true
                      : false
                  }
                  message={errors.pi_evalue_3?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_4"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evalue_4 &&
                    methods.formState.touchedFields.pi_evalue_4
                      ? true
                      : false
                  }
                  message={errors.pi_evalue_4?.message ?? "Invalid input"}
                />
              </div>
            </div>
          </div>
          <div className="custom-label mb-6 mt-16">
            Estimated Value{" "}
            <span className="custom-label-light">
              (Transaction volume of the migrated cards)
            </span>
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_1"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evolume_1 &&
                    methods.formState.touchedFields.pi_evolume_1
                      ? true
                      : false
                  }
                  message={errors.pi_evolume_1?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_2"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evolume_2 &&
                    methods.formState.touchedFields.pi_evolume_2
                      ? true
                      : false
                  }
                  message={errors.pi_evolume_2?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_3"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evolume_3 &&
                    methods.formState.touchedFields.pi_evolume_3
                      ? true
                      : false
                  }
                  message={errors.pi_evolume_3?.message ?? "Invalid input"}
                />
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_4"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_evolume_4 &&
                    methods.formState.touchedFields.pi_evolume_4
                      ? true
                      : false
                  }
                  message={errors.pi_evolume_4?.message ?? "Invalid input"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {(methods.watch("pi_migration_type") === "new-program" ||
        methods.watch("pi_migration_type") === "both") && (
        <MigrationNewProgram
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
        />
      )}
    </div>
  );
};

export default NewMigrationForm;
